import CarouselMain1 from "./Carousel";

const Main1 = () => {

  return (
        <div className="container">
          <div className="row">
            <div className="col">
              <h1>Gallery</h1>
              <CarouselMain1/>
            </div>
          </div>
        </div>
  );
}

export default Main1
